import * as React from 'react';
import customIconWrapper from './custom-icons';

const MapPinIcon = customIconWrapper(
	<>
		<g filter="url(#filter0_d_10535_33)">
			<path fillRule="evenodd" clipRule="evenodd" d="M11 100.149C11 51.9683 49.9048 13 98.0075 13C146.11 13 185.015 51.9683 185.015 100.149C185.015 152.066 130.076 223.653 107.578 250.918C102.606 256.894 93.5329 256.894 88.561 250.918C65.939 223.653 11 152.066 11 100.149ZM66.937 100.187C66.937 117.368 80.8582 131.312 98.0111 131.312C115.164 131.312 129.085 117.368 129.085 100.187C129.085 83.0063 115.164 69.0624 98.0111 69.0624C80.8582 69.0624 66.937 83.0063 66.937 100.187Z" fill='currentColor' />
		</g>
		<defs>
			<filter id="filter0_d_10535_33" x="0" y="-3" width="196.015" height="264.4" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
				<feOffset dy="-5" />
				<feGaussianBlur stdDeviation="5.5" />
				<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.34 0" />
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_10535_33" />
				<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_10535_33" result="shape" />
			</filter>
		</defs>
	</>, { viewBox: '0 0 197 256' });

export const MapPinIcon2 = customIconWrapper<{ borderColor?: string }>(({ borderColor }) => <>
	<g filter="url(#filter0_d_1566_381)">
		<path d="M22 6C13 6 8 12 8 20C8 29 17 34 21 38C21.6667 38.6667 22.3333 38.6667 23 38C27 34 36 29 36 20C36 12 31 6 22 6Z" fill="currentColor" />
		<path d="M22 6C13 6 8 12 8 20C8 29 17 34 21 38C21.6667 38.6667 22.3333 38.6667 23 38C27 34 36 29 36 20C36 12 31 6 22 6Z" stroke={borderColor ?? 'white'} strokeWidth="2.5" strokeLinejoin="round" />
	</g>
	<defs>
		<filter id="filter0_d_1566_381" x="3.75" y="3.75" width="36.5" height="41" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
			<feFlood floodOpacity="0" result="BackgroundImageFix" />
			<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
			<feOffset dy="2" />
			<feGaussianBlur stdDeviation="1.5" />
			<feColorMatrix type="matrix" values="0 0 0 0 0.08 0 0 0 0 0.1 0 0 0 0 0.14 0 0 0 0.16 0" />
			<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1566_381" />
			<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1566_381" result="shape" />
		</filter>
	</defs></>, { viewBox: '3 3 38 38' }
);

export default MapPinIcon;
